import React from "react";
import { withRouter } from "next/router";
import styles from "@aspen/theme/Savings.module.less";
import { Col, Divider, Row, Spin } from "antd";
import { type IFlexibleProducts, type IInjectProps } from "@aspen/model";
import { getComplianceTag, i18nUtil, saveComplianceTag } from "@aspen/libs";
import { Compliance, Disclaimer, ModalStakingRisk } from "@aspen/ui";
import { StakingYield } from "@aspen/widgets";

interface IProps extends IInjectProps {
  showToProfileBtn?: boolean;
}

interface IState {
  yieldProducts: IFlexibleProducts[];
  loading: boolean;
  showCompliance: boolean;
}

class Savings extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      loading: false,
      yieldProducts: [],
      showCompliance: false,
    };
  }

  componentDidMount() {
    const { router } = this.props;
    if (!getComplianceTag(router.pathname)) {
      this._showCompliance(true);
    }
  }

  render(): React.ReactNode {
    const intl = i18nUtil.t();
    const { showCompliance } = this.state;
    const { showToProfileBtn } = this.props;
    return (
      <section className={`${styles.savings} customer`}>
        <div className="customerTop">
          <Row className="top">
            <Col span={24}>
              <p className="title">{intl["compliance.yield.title"]}</p>
            </Col>
          </Row>
        </div>
        <Row className="section">
          <Spin spinning={this.state.loading}>
            <div className={styles.list}>
              <StakingYield showToProfileBtn={showToProfileBtn} />
            </div>
          </Spin>
        </Row>

        <Compliance module="staking" />
        <Divider />
        <Disclaimer />
        {showCompliance ? (
          <ModalStakingRisk
            open={showCompliance}
            onConfirm={this._onComplianceOk}
            onHide={this._onComplianceCancel}
          />
        ) : undefined}
      </section>
    );
  }

  _showCompliance = (show: boolean) => {
    this.setState({ showCompliance: show });
  };
  _onComplianceOk = () => {
    const { router } = this.props;
    saveComplianceTag(router.pathname);
    this._showCompliance(false);
  };
  _onComplianceCancel = () => {
    const { router } = this.props;
    this._showCompliance(false);
    router.back();
  };
}

export const PageYield = withRouter(Savings);
